import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import { cloneValue, expectObject, readString, splitKnown } from "../utils";

export class ProductVersionImageSideModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    name: { label: "Name", fieldType: "text" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  name!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("name", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product image side metadata");
    this.name = readString(source, "name");
    this.extra = splitKnown(source, ["name"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.name ? { name: this.name } : {}),
    };
  }
}
